export default "/images/chart_of_accounts.png?68b3d092ffe6858335fba566e4d0d69d";